/**
 * Chat Utils
 */

import ee from '../../../../../UmiCore/src/EventDriver';
import DateUtils from './DateUtils';

const ChatUtils = {
  /**
   * Sends a message to UmiCore
   * @param {String} text
   * @param {Array} images
   * @param {Array} image_flags
   */  
  sendMessage: function(text = '', payload = '', images = [], image_flags = [], render = true) {
    // console.debug(`%cLandbot debug: Message sent ${DateUtils.format(new Date(), 'HH:mm:ss.ff')}`, 'color:blue');
    ee.emit('hu-lb-sending-message'); // For input hiding
    ee.emit('hu-query-send-message', {
      message: text,
      payload: payload || text,
      images: images,
      image_flags: image_flags,
      render: render,
    });
  },

  /**
   * Triggers enable user input
   */
  enableInput: function() {
    ee.emit('hu-lb-enable-input');
  },

  /**
   * Triggers disable user input
   */
  disableInput: function() {
    ee.emit('hu-lb-disable-input');
  },

  /**
   * 
   */
  randomKey: function(ncharacters = 20) {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let text = "+";
    for (let i = 0; i < ncharacters ; i++)
      text = text.concat(chars.charAt(Math.floor(Math.random() * chars.length)));
    return text;
  }
};

export default ChatUtils;


// WEBPACK FOOTER //
// ./app/js/components/utils/ChatUtils.js